<template>
  <OurConfirmModal
    v-model="isShownModal"
    :title="$t('title.categories.delete')"
    :action-button-text="$t('button.remove')"
    color="gray"
    @actionConfirmed="onClickDeleteButton"
  >
    {{ $t("page.categories.removeConfirm") }}
  </OurConfirmModal>
</template>

<script>
import { mapActions } from "vuex";
import apolloMixin from "@/mixins/apollo.mixin";
import { deleteCatalogCategoryMutation } from "./gql/mutations";

export default {
  name: "CategoriesDeleteModal",

  mixins: [apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    categoryId: {
      type: String,
      default: "",
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    ...mapActions("catalogCategories", ["refreshCatalogCategories"]),

    closeModal() {
      this.isShownModal = false;
    },

    onClickCloseButton() {
      this.closeModal();
    },

    async onClickDeleteButton() {
      const { deleteCatalogCategory } = await this.$post(deleteCatalogCategoryMutation, {
        id: this.categoryId,
      });

      if (deleteCatalogCategory?.id) {
        this.refreshCatalogCategories();

        if (this.$route.name !== "Categories") {
          this.$router.push({ name: "Categories" });
        }
      }

      this.$emit("deleteCategory");
    },
  },
};
</script>
